<c-container class="mt-5">
  <h2>Causable Admin Reporting</h2>

  @if(game) {
    <app-reports [gameSetter]="game"></app-reports>
  }
</c-container>
